import classNames from 'classnames';

import { ForwardMessage } from '../../components/ForwardMessage/ForwardMessage';
import { QuotedMessage } from '../../components/QuotedMessage/QuotedMessage';
import { SenderName } from '../../components/SenderName/SenderName';
import styles from './styles.m.scss';

const Header = ({ message, isShowForward }) => {
  const senderNameClasses = classNames(styles.senderName, {
    [styles.wideGap]: message.repliedMessage || message.quote || isShowForward,
    [styles.dynamicLength]: !message.repliedMessage && !isShowForward && !message.quote,
  });

  return (
    <div className={styles.header}>
      <SenderName
        message={message}
        className={senderNameClasses}
      />
      <QuotedMessage message={message} />
      {isShowForward && (
        <ForwardMessage
          className={styles.forward}
          message={message}
        />
      )}
    </div>
  );
};

export default Header;
